import { createSelector } from 'reselect';
import { normalizeRequestData } from '@mews-commander/legacy-data-structures';
import { DEFAULT_VISIT_STAY } from '../constants';
import { getResourcesExportData } from './resources';
import { getCategoriesExportData } from './categories';
import { getSettingsExportData } from './settings';

export const getGeneratedExportData = createSelector(
    getSettingsExportData,
    getCategoriesExportData,
    getResourcesExportData,
    (settingsData, categoriesData, resourcesData) =>
        normalizeRequestData({
            ...settingsData,
            visits: [DEFAULT_VISIT_STAY],
            resourceCategories: categoriesData,
            resources: resourcesData,
        })
);
